/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberDinghyBookingController', MemberDinghyBookingController);

    MemberDinghyBookingController.$inject = ['$state', 'MemberDinghyBooking', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$scope'];

    function MemberDinghyBookingController($state, MemberDinghyBooking, ParseLinks, AlertService, paginationConstants, pagingParams, $scope) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.loadAll = loadAll;

        vm.setArchive = setArchive;
        vm.archive = pagingParams.archive;

        loadAll();

        function loadAll () {
            MemberDinghyBooking.query({
                archive: vm.archive
            }, onSuccess, onError);
            function onSuccess(data) {
                vm.bookings = data;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                archive: vm.archive
            });
        }

        function setArchive(archive) {
            vm.archive = archive;
            vm.transition();
        }

        $scope.getEditOrBookState = function(booking) {
            return booking.bookingStatus == null && booking.priceNet == -1 ? "member.dinghy-events.book({id: booking.eventId})" : "member.dinghy-booking.detail({id: booking.eventId})";
        }
    }
})();
